<div class="highlight-bar" [style]="'height : ' + height + ';'">
